import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { Link, Redirect, useLocation } from "react-router-dom";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { resetPassword } from "../_redux/authCrud";
import { toast } from "react-toastify";
import { toastOption } from "../../../../_metronic/_helpers";
import { parse } from "query-string";

const initialValues = {
  password: "",
  password_confirmation: ""
};

function ResetPassword(props) {
  const { search } = useLocation();
  const queryString = parse(search);
  const { reset_token } = queryString;

  const [isRequested, setIsRequested] = useState(false);
  const ResetPasswordSchema = Yup.object().shape({
    password: Yup.string().required("Harap isi password"),
    password_confirmation: Yup.string().when("password", {
      is: password => password && password.length > 0,
      then: Yup.string()
        .oneOf(
          [Yup.ref("password"), null],
          "Konfirmasi password harus sama dengan password!"
        )
        .required("Harap isi kondirmasi password!")
    })
  });

  const getInputClasses = fieldname => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ResetPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting, resetForm }) => {
      const { password, password_confirmation } = values;
      if (password !== password_confirmation) {
        toast.error(
          "Konfirmasi password tidak sama dengan password!",
          toastOption
        );
        return;
      }
      if (!reset_token) {
        toast.error("Reset token tidak ditemukkan!", toastOption);
        return;
      }

      resetPassword({ ...values, reset_token })
        .then(res => {
          resetForm();
          setIsRequested(true);
          setStatus(res);
        })
        .catch(error => {
          setIsRequested(false);
          setSubmitting(false);
          setStatus(error.response.data);
          // setStatus(
          //   intl.formatMessage(
          //     { id: "AUTH.VALIDATION.NOT_FOUND" },
          //     { name: values.email }
          //   )
          // );
        });
    }
  });

  const getAlert = () => {
    let alert = <></>;
    if (formik.status) {
      if (formik.status.status === 200) {
        alert = (
          <div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
            <div className="alert-text font-weight-bold">
              Berhasil mengubah password!
              <br />
              <a href="/auth/login">Klik untuk login</a>
            </div>
          </div>
        );
      } else {
        alert = (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">
              {formik.status.message}
            </div>
          </div>
        );
      }
    }

    return alert;
  };

  return (
    <>
      <div className="login-form login-forgot" style={{ display: "block" }}>
        <div className="text-center mb-10 mb-lg-20">
          <h3 className="font-size-h1">Atur ulang kata sandi</h3>
          <div className="text-muted font-weight-bold">
            Masukkan password baru yang akan diubah
          </div>
        </div>
        <form
          onSubmit={formik.handleSubmit}
          className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
        >
          {getAlert()}
          <div className="form-group fv-plugins-icon-container">
            <label>Password Baru</label>
            <input
              name="password"
              type="password"
              className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                "password"
              )}`}
              {...formik.getFieldProps("password")}
            />
            {formik.touched.password && formik.errors.password ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.password}</div>
              </div>
            ) : null}
          </div>
          <div className="form-group fv-plugins-icon-container">
            <label>Konfirmasi Password</label>
            <input
              name="password_confirmation"
              type="password"
              className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                "password_confirmation"
              )}`}
              {...formik.getFieldProps("password_confirmation")}
            />
            {formik.touched.password_confirmation &&
            formik.errors.password_confirmation ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">
                  {formik.errors.password_confirmation}
                </div>
              </div>
            ) : null}
          </div>
          <div className="form-group d-flex flex-wrap flex-center">
            <button
              id="kt_login_forgot_submit"
              type="submit"
              className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
              disabled={formik.isSubmitting}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(ResetPassword));
